import { useMemo } from 'react';
import { composedMap } from '../shape-map';
import { formatAuditEntry } from '../format';
import useAuditLogPredecessors from './useAuditLogPredecessors';

const UNMAPPED_ROW_ENTRY = Object.freeze({
  entity: null,
  identity: 'event',
  renderMode: 'keyValue',
  createsRecord: false,
});

export default function useFormattedAuditRows({ rows, hasActiveFilters, sortDirection }) {
  const { predecessorByRowId, predecessorEntryByRowId, status } = useAuditLogPredecessors({
    rows,
    hasActiveFilters,
    sortDirection,
  });

  const formattedEntryByRowId = useMemo(() => {
    const formatted = new Map();
    rows.forEach(row => {
      const rowEntry = composedMap[row.action] ?? UNMAPPED_ROW_ENTRY;
      formatted.set(
        row.id,
        formatAuditEntry({
          row,
          rowEntry,
          predecessor: predecessorByRowId.get(row.id) ?? null,
          predecessorEntry: predecessorEntryByRowId.get(row.id) ?? null,
          predecessorStatus: status,
        })
      );
    });
    return formatted;
  }, [rows, predecessorByRowId, predecessorEntryByRowId, status]);

  return { formattedEntryByRowId };
}
